import React from "react";
import PreviewBackground from "@assets/images/pages/workbench/canvas_background.png";
import { PulseLoader } from "halogenium";
import GoogleVision from "../../../helpers/google_vision";
import LinkPreview from "../../../helpers/link_preview";

export default class FilePreview extends React.Component {
  constructor(...args) {
    super(...args);
    this.reverseImageSearch = this.reverseImageSearch.bind(this);
    this.toggleSearchResults = this.toggleSearchResults.bind(this);
    this.state = {
      search_results_open: false,
      search_results: null
    };
  }

  componentDidMount() {
    this.reverseImageSearch();
  }

  toggleSearchResults() {
    this.setState({ search_results_open: !this.state.search_results_open });
  }

  reverseImageSearch() {
    let { file } = this.props;
    if (GoogleVision.hasSupportFor(file.filetype)) {
      let vision = new GoogleVision(file.url);
      vision.detectSafeSearch().then(safe_for_work => {
        if (safe_for_work) {
          vision.reverseImageSearch().then(search_results => {
            if (!!search_results) {
              let search_previews = search_results
                .map(url => {
                  let link = document.createElement("a");
                  link.href = url;
                  return LinkPreview.embedlyPreview(link.hostname).then(
                    result => {
                      try {
                        result.url = url;
                        return result;
                      } catch (error) {
                        return null;
                      }
                    }
                  );
                })
                .filter(preview => {
                  return !!preview;
                });
              Promise.all(search_previews).then(previews => {
                let filtered_previews = previews.filter(preview => !!preview);
                this.setState({ search_results: filtered_previews });
              });
            }
          });
        }
      });
    }
  }

  humanFriendlyFileSize() {
    let { size } = this.props.file;
    if (size < 1024) {
      size = Math.round(size / 1024 * 100) / 100;
      return `${size} bytes`;
    } else if (size < 1024 * 1024) {
      size = Math.round(size / 1024 * 100) / 100;
      return `${size} KB`;
    } else if (size < 1024 * 1024 * 1024) {
      size = Math.round(size / 1024 / 1024 * 100) / 100;
      return `${size} MB`;
    } else {
      size = Math.round(size / 1024 / 1024 / 1024 * 100) / 100;
      return `${size} GB`;
    }
  }

  renderReverseImageResults() {
    let { search_results } = this.state;
    return search_results.map((search_result, index) => {
      let { url, thumbnail_url, title, description } = search_result;
      return (
        <div key={index} className="search-result">
          <div className="preview-image-container">
            <img className="preview-image no-select" src={thumbnail_url} />
          </div>
          <div className="preview-text-container">
            <h5 className="preview-title">{title}</h5>
            <p className="preview-description">{description}</p>
            <a className="preview-url no-line" target="_blank" href={url}>
              {url}
            </a>
          </div>
        </div>
      );
    });
  }

  renderPreview() {
    let { requires_thumbnail, thumbnail_url, file } = this.props;
    if (this.state.search_results_open) {
      return (
        <div className="search-results-list">
          {this.renderReverseImageResults()}
        </div>
      );
    } else if (thumbnail_url) {
      return <img src={thumbnail_url} alt={file.name} />;
    } else if (requires_thumbnail) {
      return (
        <PulseLoader className="card-loader" color="#4F94E3" size="20px" />
      );
    } else {
      return <img src={file.url} alt={file.name} />;
    }
  }

  renderDimensions() {
    let { file } = this.props;
    if (file.width && file.height) {
      return `${file.width} × ${file.height} · ${this.humanFriendlyFileSize()}`;
    } else {
      return this.humanFriendlyFileSize();
    }
  }

  renderReverseImageResultsLink() {
    let { search_results, search_results_open } = this.state;
    if (!!search_results && search_results.length > 0) {
      if (search_results_open) {
        return (
          <div
            className="search-results-link"
            onClick={this.toggleSearchResults}
          >
            <a className="no-line no-select" href="javascript:void(0);">
              Back to preview
            </a>
          </div>
        );
      } else {
        return (
          <div
            className="search-results-link"
            onClick={this.toggleSearchResults}
          >
            <a className="no-line no-select" href="javascript:void(0);">
              Check out where this file appears on the web
            </a>
          </div>
        );
      }
    }
  }

  render() {
    return (
      <div
        className="file-preview"
        style={{ backgroundImage: `url(${PreviewBackground})` }}
      >
        {this.renderPreview()}
        {this.state.search_results_open ? (
          ""
        ) : (
          <div className="dimensions">{this.renderDimensions()}</div>
        )}
        {this.renderReverseImageResultsLink()}
      </div>
    );
  }
}
